export default {
  title: 'Download',
  author: ' iA Private Wealth app',
  buttonLabel: 'Install',
  closeButtonLabel: 'Close',
};
